import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const NavigationContext = createContext({ previousPage: '', currentPage: '', wasFlyerDetailsPage: false, isLoading: false });

export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const [navigationState, setNavigationState] = useState({
    previousPage: '',
    currentPage: location.pathname,
  });

  useEffect(() => {
    setNavigationState((prev) => ({
      previousPage: prev.currentPage,
      currentPage: pathname,
    }));
  }, [pathname]);

  const props = {
   ...navigationState,
   wasFlyerDetailsPage: Boolean(navigationState.previousPage.match("flyer")),
   isLoading: navigationState.currentPage !== pathname
  }

  return (
    <NavigationContext.Provider value={props}>
      {children}
    </NavigationContext.Provider>
  );
};
